import type { BridgeMessage } from '../types/bridge';

export function postToHost(
  event: BridgeMessage['event'],
  payload: Partial<BridgeMessage['payload']> = {},
): void {
  const message: BridgeMessage = {
    source: 'avatar_core_iframe',
    event,
    payload: {
      timestamp: Date.now(),
      ...payload,
    },
  };
  window.parent.postMessage(message, '*');
}

export function readQueryParams(): {
  surface: 'web' | 'webview';
  publishableKey: string;
  locale: string;
} {
  const params = new URLSearchParams(window.location.search);
  const surface = params.get('surface') === 'webview' ? 'webview' : 'web';
  const publishableKey = params.get('pk') ?? '';
  const locale =
    params.get('lang') || params.get('locale') || navigator.language || 'en';
  return { surface, publishableKey, locale };
}

export function resolvePublishableKey(payload: {
  publishableKey?: string;
  publicKey?: string;
}): string {
  return payload.publishableKey || payload.publicKey || '';
}
